import { createFileRoute } from '@tanstack/react-router'
import { Navbar } from '@/components/Navbar'
import { HeroSection } from '@/components/HeroSection'

export const Route = createFileRoute('/')({
  component: LandingPage,
})

function LandingPage() {
  return (
    <main className="bg-muted flex min-h-screen flex-col gap-12 pt-16 pb-8 lg:pt-24">
      <Navbar />
      <HeroSection />
    </main>
  )
}
